import {Column, Row} from "tabloom"
import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, Text, View} from "shared/base"
import {digg} from "diggerize"
import mergeStyles from "@kaspernj/api-maker/build/merge-styles"
import OptionsButton from "components/school-classes/options-button"
import React from "react"
import {styles} from "../class-status-route"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"

/**
 * @typedef {object} RoutesUserClassStatusSchoolClassRowProps
 * @property {unknown} lastRow
 * @property {unknown} schoolClassData
 */

/** @typedef {object} RoutesUserClassStatusSchoolClassRowState */

/**
 * @extends {ShapeComponent<RoutesUserClassStatusSchoolClassRowProps, RoutesUserClassStatusSchoolClassRowState>}
 */
class RoutesUserClassStatusSchoolClassRow extends ShapeComponent {
  static propTypes = propTypesExact({
    lastRow: PropTypes.bool.isRequired,
    schoolClassData: PropTypes.object.isRequired
  })

  setup() {
    const {t} = useI18n({namespace: "js.routes.user.class_status.school_class_row"})

    this.schoolClass = this.p.schoolClassData.schoolClass
    this.t = t
  }

  render() {
    const {lastRow, schoolClassData} = this.p
    const schoolClass = schoolClassData.schoolClass
    const latestMoodAverage = digg(schoolClassData, "latestMoodAverage")

    return (
      <Row
        dataSet={this.cache("rowDataSet", {
          schoolClassId: schoolClass.id()
        }, [schoolClass.id()])}
        style={this.cache("rowStyle", {
          backgroundColor: "#e5dfff",
          borderColor: "#e5dfff",
          borderBottomWidth: lastRow ? 1 : 0,
          borderLeftWidth: 1,
          borderRightWidth: 1,
          borderStyle: "solid",
          borderBottomLeftRadius: lastRow ? 24 : 0,
          borderBottomRightRadius: lastRow ? 24 : 0
        }, [lastRow])}
        testID="routes/user/class-status/school-class-row"
      >
        <Column style={this.nameColumnStyle ||= {paddingLeft: 12}}>
          <View
            style={this.cache("nameContainerViewStyle", {
              width: "100%",
              height: "100%",
              padding: 18,
              backgroundColor: "#fff",
              borderBottomLeftRadius: lastRow ? 10 : 0
            }, [lastRow])}
          >
            <Text style={this.nameTextStyle ||= mergeStyles([styles.columnText, {fontWeight: "bold"}])}>
              {schoolClass.interpretedLegalName()}
            </Text>
          </View>
        </Column>
        <Column style={this.nicknameColumnStyle ||= {padding: 18, backgroundColor: "#fff"}}>
          <Text style={styles.columnText}>{schoolClass.interpretedName()}</Text>
        </Column>
        <Column style={this.teachersColumnStyle ||= {padding: 18, backgroundColor: "#fff"}}>
          <Text style={styles.columnText}>{Object.keys(schoolClassData.teachers).length}</Text>
        </Column>
        <Column style={this.topPositiveScoreFactorColumnStyle ||= {padding: 18, backgroundColor: "#fff"}}>
          <Text style={styles.columnText}>{digg(schoolClassData, "topPositiveScoreFactor")?.name()}</Text>
        </Column>
        <Column style={this.topNegativeScoreFactorColumnStyle ||= {padding: 18, backgroundColor: "#fff"}}>
          <Text style={styles.columnText}>{digg(schoolClassData, "topNegativeScoreFactor")?.name()}</Text>
        </Column>
        <Column style={this.moodAverageColumnStyle ||= {padding: 18, backgroundColor: "#fff"}}>
          <Text style={styles.columnText}>{digg(schoolClassData, "moodAverage")}</Text>
        </Column>
        <Column style={this.latestMoodAverageColumnStyle ||= {padding: 18, backgroundColor: "#fff"}}>
          <Text style={styles.columnText}>{latestMoodAverage && Math.round(latestMoodAverage, 2)}</Text>
        </Column>
        <Column style={this.checkInsCountColumnStyle ||= {padding: 18, backgroundColor: "#fff"}} testID="check-ins-column">
          <Text style={styles.columnText}>{digg(schoolClassData, "checkInsCount")}</Text>
        </Column>
        <Column style={this.brainBreaksCountStyle ||= {padding: 18, backgroundColor: "#fff"}} testID="brain-breaks-column">
          <Text style={styles.columnText}>{digg(schoolClassData, "brainBreaksCount")}</Text>
        </Column>
        <Column style={this.challengesCountColumnStyle ||= {padding: 18, backgroundColor: "#fff"}} testID="challenges-column">
          <Text style={styles.columnText}>{digg(schoolClassData, "challengesCount")}</Text>
        </Column>
        <Column style={this.unicornEffectsColumnStyle ||= {padding: 18, backgroundColor: "#fff"}}>
          <Text style={styles.columnText}>{digg(schoolClassData, "unicornEffectsCount")}</Text>
        </Column>
        <Column style={this.activeCoursesColumnStyle ||= {padding: 18, backgroundColor: "#fff"}}>
          <Text style={styles.columnText}>{digg(schoolClassData, "activeCourses")}</Text>
        </Column>
        <Column style={this.actionsColumnStyle ||= {justifyContent: "center", padding: 18, backgroundColor: "#fff"}}>
          <OptionsButton schoolClass={schoolClass} />
        </Column>
      </Row>
    )
  }
}

export default memo(shapeComponent(RoutesUserClassStatusSchoolClassRow))
